/**
 * Acesso parcial (JWT accessLevel === 'partial').
 *
 * Perfil de empresa com contrato rescindido. Mantém somente a consulta dos
 * dados já existentes: as funcionalidades de solicitação/alteração e os
 * documentos auxiliares saem do portal.
 */
export const PARTIAL_ACCESS_LEVEL = 'partial';

/**
 * Rotas bloqueadas para o acesso parcial. Também usadas pelo menu lateral
 * e pelos acessos rápidos para esconder os itens correspondentes.
 */
export const PARTIAL_ACCESS_BLOCKED_ROUTES = [
  // Gerenciar Beneficiários - ações da subpasta (steps 2 a 7)
  '/beneficiarios/2',
  '/beneficiarios/3',
  '/beneficiarios/4',
  '/beneficiarios/5',
  '/beneficiarios/6',
  '/beneficiarios/7',
  '/carencia',
  '/rescindir-beneficiario',
  '/solicita-segunda-via-cartao',
  // Consultar Solicitações
  '/consulta-segunda-via-cartao',
  '/consulta-alteracoes-cadastrais',
  '/consulta-rescisao',
  '/consulta-alteracoes-contrato-cnpj',
  '/consulta-alteracoes-produto',
  '/consulta-inclusao-beneficiario',
  // Informações Financeiras
  '/indice-reajustes',
  '/sinistralidade',
  // Inclusão de Beneficiário
  '/incluir-beneficiario',
  '/incluir-beneficiario-gerar-link',
  '/incluir-beneficiario-por-lote',
  '/detalhes-lote',
  // Documentos Auxiliares
  '/faq',
  '/tutoriais',
  '/manuais-e-arquivos',
  '/documentos-contrato',
  // Ouvidoria
  '/ouvidoria',
];

/**
 * Relatórios retirados do menu lateral / Relatórios.
 * A listagem vem da API, então o filtro é feito pelo nome do relatório.
 */
export const PARTIAL_ACCESS_BLOCKED_REPORTS = [
  'Despesa Médica por Beneficiário',
  'Indicadores do Plano',
  'Receitas e Despesas por Contrato',
];

const DIACRITICS = new RegExp('[\\u0300-\\u036f]', 'g');

const normalize = (value: string) =>
  value.normalize('NFD').replace(DIACRITICS, '').trim().toLowerCase();

/**
 * @description true quando a rota (ou uma rota filha dela) está bloqueada
 * para o acesso parcial.
 */
export function isRouteBlockedForPartialAccess(path?: string | null): boolean {
  if (!path) return false;
  const clean = path.split('?')[0].replace(/\/$/, '');
  return PARTIAL_ACCESS_BLOCKED_ROUTES.some(
    (blocked) => clean === blocked || clean.startsWith(`${blocked}/`),
  );
}

/**
 * @description true quando o relatório está bloqueado para o acesso parcial.
 */
export function isReportBlockedForPartialAccess(name?: string | null): boolean {
  if (!name) return false;
  return PARTIAL_ACCESS_BLOCKED_REPORTS.some(
    (blocked) => normalize(blocked) === normalize(name),
  );
}
